const currentYear = new Date().getFullYear();
const yearNodes = document.querySelectorAll('[data-current-year]');

for (const node of yearNodes) {
  node.textContent = String(currentYear);
}

const THEME_KEY = 'idoneos-theme';
const themeToggle = document.querySelector('[data-theme-toggle]');

const getSystemTheme = () => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const applyTheme = (theme) => {
  const resolved = theme === 'system' ? getSystemTheme() : theme;
  document.documentElement.setAttribute('data-theme', resolved);
};

const initTheme = () => {
  const stored = localStorage.getItem(THEME_KEY) || 'system';
  applyTheme(stored);

  const media = window.matchMedia('(prefers-color-scheme: dark)');
  media.addEventListener('change', () => {
    const current = localStorage.getItem(THEME_KEY) || 'system';
    if (current === 'system') {
      applyTheme('system');
    }
  });
};

const toggleTheme = () => {
  const current = localStorage.getItem(THEME_KEY) || 'system';
  const resolved = current === 'system' ? getSystemTheme() : current;
  const next = resolved === 'dark' ? 'light' : 'dark';
  localStorage.setItem(THEME_KEY, next);
  applyTheme(next);
};

if (themeToggle) {
  themeToggle.addEventListener('click', () => {
    toggleTheme();
  });
}

initTheme();

const loadScript = (src) => new Promise((resolve, reject) => {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.onload = resolve;
  script.onerror = reject;
  document.head.appendChild(script);
});

const renderMermaid = async () => {
  const blocks = Array.from(document.querySelectorAll('pre > code.language-mermaid'));
  if (!blocks.length) {
    return;
  }

  const { default: mermaid } = await import('/assets/vendor/mermaid.esm.min.mjs');
  mermaid.initialize({ startOnLoad: false, theme: 'neutral' });

  for (const block of blocks) {
    const pre = block.parentElement;
    const container = document.createElement('div');
    container.className = 'mermaid';
    container.textContent = block.textContent || '';
    pre.replaceWith(container);
  }

  await mermaid.run({ querySelector: '.mermaid' });
};

const renderGraphviz = async () => {
  const blocks = Array.from(document.querySelectorAll('pre > code.language-graphviz, pre > code.language-dot'));
  if (!blocks.length) {
    return;
  }

  await loadScript('https://cdn.jsdelivr.net/npm/viz.js@2.1.2/viz.js');
  await loadScript('https://cdn.jsdelivr.net/npm/viz.js@2.1.2/full.render.js');

  if (!window.Viz) {
    return;
  }

  const viz = new window.Viz();
  for (const block of blocks) {
    const pre = block.parentElement;
    const source = block.textContent || '';
    try {
      const svg = await viz.renderString(source);
      const wrapper = document.createElement('div');
      wrapper.className = 'graphviz';
      wrapper.innerHTML = svg;
      pre.replaceWith(wrapper);
    } catch (error) {
      console.error('Graphviz render error', error);
    }
  }
};

const run = async () => {
  await renderMermaid();
  await renderGraphviz();
};

run();

const sidebarToggle = document.querySelector('.sidebar-toggle');
const sidebar = document.querySelector('.site-sidebar');
const sidebarOverlay = document.querySelector('[data-sidebar-overlay]');

const closeSidebar = () => {
  if (!sidebar) {
    return;
  }
  sidebar.classList.remove('is-open');
  if (sidebarOverlay) {
    sidebarOverlay.classList.remove('is-open');
  }
  if (sidebarToggle) {
    sidebarToggle.setAttribute('aria-expanded', 'false');
  }
};

const openSidebar = () => {
  if (!sidebar) {
    return;
  }
  sidebar.classList.add('is-open');
  if (sidebarOverlay) {
    sidebarOverlay.classList.add('is-open');
  }
  if (sidebarToggle) {
    sidebarToggle.setAttribute('aria-expanded', 'true');
  }
};

if (sidebarToggle && sidebar) {
  sidebarToggle.addEventListener('click', () => {
    const isOpen = sidebar.classList.contains('is-open');
    if (isOpen) {
      closeSidebar();
      return;
    }
    openSidebar();
  });
}

if (sidebarOverlay) {
  sidebarOverlay.addEventListener('click', () => {
    closeSidebar();
  });
}

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') {
    return;
  }
  closeSidebar();
});
